import type { ErrorCode } from '@banger/shared';

export function joinErrorCopy(code: ErrorCode): string {
  switch (code) {
    case 'ROOM_NOT_FOUND': return 'No game with that code.';
    case 'ROOM_FULL': return 'This game is full (12 players).';
    case 'NAME_TAKEN': return 'Someone already has that name.';
    case 'BAD_NAME': return 'Pick a name (up to 16 letters).';
    case 'KICKED': return 'The host removed you.';
    default: return 'Something went wrong. Try again.';
  }
}
